<template>
  <v-container fluid>
    <!-- Sticky Title -->
    <div v-if="isWindowWide">
      <div class="sticky-title" ref="title">
        <h1 class="text-page">Videos | Shorts</h1>
      </div>

      <!-- Video Content -->
      <div class="video-carousel">
        <VideoCard :videos="videos" />
        <VideoCard :videos="shorts" :crop-thumbnail="false" />
      </div>
    </div>
    <!-- End Sticky Title -->
    <div v-else>
      <div class="sticky-title" ref="title">
        <h1 class="text-page">{{ containerTitle }}</h1>
        <v-switch
          class="sticky-switch custom-switch"
          v-model="showShorts"
          base-color="#d9d9d9"
          color="#fefbe7"
        ></v-switch>
      </div>

      <div class="video-carousel" v-if="!showShorts">
        <VideoCard :videos="videos" />
      </div>
      <div class="video-carousel" v-else>
        <VideoCard :videos="shorts" :crop-thumbnail="false" />
      </div>
    </div>

    <v-container
      v-if="galleryItems.length > 0"
      fluid
      class="showcase-container"
    >
      <!-- Showcase Title -->
      <div class="sticky-title" ref="title" style="margin-top: 50px">
        <h1 class="text-page">Showcase!</h1>
      </div>

      <!-- Gallery Items -->
      <v-row>
        <v-col v-for="item in galleryItems" :key="item.id" cols="12">
          <GalleryItemCard :galleryItem="item" />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { WS } from "@/services/WS"; // Correct way to import named export
import VideoCard from "../components/VideoCard.vue";
import GalleryItemCard from "../components/GalleryItemCard.vue";

export default {
  name: "App",
  components: {
    VideoCard,
    GalleryItemCard,
  },
  computed: {
    containerTitle() {
      return this.showShorts ? "Shorts" : "Videos";
    },
  },
  data() {
    return {
      isWindowWide: window.innerWidth > 924,
      windowWidth: window.innerWidth,
      showShorts: false,
      videos: [], // Start with an empty array
      shorts: [],
      galleryItems: [],
    };
  },
  created() {
    this.fetchVideos()
      .then(() => {
        console.log("Videos fetched successfully:", this.videos);
      })
      .catch((error) => {
        console.error("Error fetching videos:", error);
      });
    this.fetchShorts()
      .then(() => {
        console.log("Shorts fetched successfully:", this.videos);
      })
      .catch((error) => {
        console.error("Error fetching shorts:", error);
      });
    this.loadGalleryItems();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.isWindowWide = window.innerWidth > 924;
      this.windowWidth = window.innerWidth;
    },
    async loadGalleryItems() {
      WS.getGalleryItems()
        .then((galleryItems) => {
          this.galleryItems = galleryItems;
        })
        .catch((error) => {
          console.error("Failed to load gallery items", error);
        });
    },
    async fetchVideos() {
      try {
        const fetchedVideos = await WS.getVideos();
        this.videos = fetchedVideos.sort((a, b) => {
          return new Date(b.publishedAt) - new Date(a.publishedAt);
        });
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      }
    },
    async fetchShorts() {
      try {
        const fetchedShorts = await WS.getShorts();
        this.shorts = fetchedShorts.sort((a, b) => {
          return new Date(b.publishedAt) - new Date(a.publishedAt);
        });
      } catch (error) {
        console.error("Failed to fetch shorts:", error);
      }
    },
  },
};
</script>
